// ─── Design tokens (FigmaDesign/src/styles/theme.css, light theme) ────────────
export const TOKENS = {
  background: "#F4F4F8",
  card: "#FFFFFF",
  foreground: "#1A1A2E",
  primary: "#0077FF",
  primaryForeground: "#FFFFFF",
  muted: "#EDEDF2",
  mutedForeground: "#888899",
  inputBackground: "#F0F0F6",
  destructive: "#E5373A",
  border: "rgba(0, 0, 0, 0.07)",
};

export const SHADOW = {
  xs: "0 1px 6px rgba(0,0,0,0.05)",
  sm: "0 1px 8px rgba(0,0,0,0.05)",
  card: "0 2px 12px rgba(0,0,0,0.06)",
  nav: "0 8px 32px rgba(0,0,0,0.12)",
  fab: "0 8px 24px rgba(0,119,255,0.35)",
};

// ─── Auth screen ──────────────────────────────────────────────────────────────
export const pageCenterStyle = {
  minHeight: "100vh",
  background: TOKENS.background,
  padding: "24px 20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const loaderPageStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: TOKENS.background,
};

export const loginCardStyle = {
  width: "100%",
  maxWidth: 420,
  background: TOKENS.card,
  borderRadius: 24,
  padding: 24,
  boxShadow: SHADOW.card,
};

export const loginTitleStyle = {
  margin: 0,
  fontSize: 26,
  fontWeight: 800,
  lineHeight: 1.15,
  color: TOKENS.foreground,
};

export const mutedTextStyle = {
  margin: "6px 0 0",
  fontSize: 13,
  color: TOKENS.mutedForeground,
};

export const errorTextStyle = {
  margin: "12px 0 0",
  fontSize: 13,
  fontWeight: 600,
  color: TOKENS.destructive,
};

export const primaryButtonStyle = {
  marginTop: 16,
  width: "100%",
  minHeight: 48,
  padding: "14px 16px",
  borderRadius: 16,
  border: "none",
  background: TOKENS.primary,
  color: TOKENS.primaryForeground,
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "inherit",
  cursor: "pointer",
};

// ─── Entry form (consumed by EntryFormSheet) ──────────────────────────────────
export const formCardStyle = {
  background: "transparent",
  border: "none",
  padding: 0,
  marginBottom: 0,
};

export const typeButtonsStyle = {
  display: "flex",
  gap: 8,
  marginBottom: 12,
  flexWrap: "wrap",
};

export const typeButtonStyle = {
  minHeight: 40,
  padding: "8px 16px",
  borderRadius: 999,
  border: "none",
  background: TOKENS.muted,
  fontSize: 13,
  fontWeight: 600,
  fontFamily: "inherit",
  cursor: "pointer",
};

export const formRowStyle = {
  display: "flex",
  gap: 8,
  marginTop: 8,
};

export const inputStyle = {
  width: "100%",
  minHeight: 48,
  padding: "13px 16px",
  borderRadius: 16,
  border: `1px solid ${TOKENS.border}`,
  background: TOKENS.inputBackground,
  color: TOKENS.foreground,
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

export const saveButtonStyle = {
  marginTop: 16,
  width: "100%",
  minHeight: 48,
  padding: "14px 16px",
  borderRadius: 16,
  border: "none",
  background: TOKENS.primary,
  color: TOKENS.primaryForeground,
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "inherit",
  cursor: "pointer",
};
